export default "__VITE_ASSET__CLQdhnf$__"